import React from 'react';
import { Container } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton';
import s from './HomePageCategorySkeleton.css'

function HomePageCategorySkeleton() {
    return (
        <div className={s.topCategorySkeletonContainer}>
            <Container>
                <Skeleton className={s.topCategorySkeletonHeading} />
                <div className={s.topCategorySkeletonList}>
                    {[1, 2, 3, 4].map((_, index) => {
                        return (
                            <div className={s.topCategorySkeletonListItem} key={index}>
                                <div className={s.topCategorySkeletonListImgContainer}>
                                    <Skeleton className={s.topCategorySkeletonListImg} />
                                </div>
                                <div className={s.topCategorySkeletonListInfo}>
                                    <Skeleton className={s.topCategorySkeletonListTitle} />
                                    <div className={s.topCategorySkeletonListDescBox}>
                                        <Skeleton className={s.topCategorySkeletonListDesc} />
                                        <Skeleton className={s.topCategorySkeletonListDesc} />
                                        <Skeleton className={s.topCategorySkeletonListDesc} />
                                        <Skeleton className={s.topCategorySkeletonListDesc} />
                                        <Skeleton className={s.topCategorySkeletonListDesc} />
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Container>
        </div>
    )
}

export default withStyles(s)(HomePageCategorySkeleton);
